import { formatDate } from "@/BaseComponent";
import { ResultDetail } from "./api/ai";

export const detailInfo = (data: any) => {
    const nationList = data.strNation?.join(", ");
    return `
    <div class="thumb">
        <img 
			class="${data.imgPath ? "blur" : ""}"
			src="${
                data.imgPath ? data.imgPath : require("@/assets/common/NoImg.png")
            }" alt="" onerror="this.src='${require("@/assets/common/NoImg.png")}'"
		>
    </div>
    <div class="txt ">
        <div class="txt_flex">
            <ul class="pop_con_w_50">
                <li>
                    <div class="pop_con_tit">연번</div>
                    <div class="pop_con_desc">${data.idx}</div>
                </li>
                <li>
                    <div class="pop_con_tit">검색키워드</div>
                    <div class="pop_con_desc">${data.keyword}</div>
                </li>
                <li>
                    <div class="pop_con_tit">검색유형</div>
                    <div class="pop_con_desc">${data.strType}</div>
                </li>

            </ul>
            <ul class="pop_con_w_50">
                <li>
                    <div class="pop_con_tit">검색일시</div>
                    <div class="pop_con_desc">${formatDate(data.createDate)}</div>
                </li>
            </ul>
        </div>
        <ul class="pop_con_w_100">
            <li>
                <div class="pop_con_tit">국적</div>
                <div class="pop_con_desc">${nationList}</div>
            </li>
            <li>
                <div class="pop_con_tit">SNS</div>
                <div>
                    <div class="pop_sns_box">
                        <span style="display:${
                            data.isTwitter === 1 ? "" : "none;"
                        }"><img src="${require("@/assets/sns/Twitter.png")}"></span>
                        <span style="display:${data.isGoogle === 1 ? "" : "none;"}"><img src="${require("@/assets/sns/Google.png")}"></span>
                        <span style="display:${data.isNaver === 1 ? "" : "none;"}"><img src="${require("@/assets/sns/Naver.png")}"></span>
                        <span style="display:${
                            data.isYoutube === 1 ? "" : "none;"
                        }"><img src="${require("@/assets/sns/Youtube.png")}"></span>
                        <span style="display:${
                            data.isInstagram === 1 ? "" : "none;"
                        }"><img src="${require("@/assets/sns/Instagram.png")}"></span>
                    </div>
                </div>
            </li>

        </ul>
    </div>
    `;
};

export const resultInfo = (data: any, type: string, detailType: string) => {
    return `
        <div class="thumb">
            <img
			 class="${data.imgPath ? "blur" : ""}"
			 src="${
                 data.imgPath ? data.imgPath : require("@/assets/common/NoImg.png")
             }" alt="" onerror="this.src='${require("@/assets/common/NoImg.png")}'">
        </div>
        <div class="txt ">
            <div class="txt_flex">
                <ul class="pop_con_w_50">
                    <li>
                        <div class="pop_con_tit">고유번호</div>
                        <div class="pop_con_desc">${data.idx}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">국적</div>
                        <div class="pop_con_desc">${data.strNation}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">URL</div>
                        <div class="pop_con_desc" style='display:${data.siteUrl ? "" : "none;"}'>
                            <span id='site_Url'>
                                <a class="url_con" href="${data.siteUrl}" target="_blank">
                                    ${data.siteUrl ? data.siteUrl : ""}
                                </a>
                            </span>
                            <button type="button" class="copy_btn" onclick="handleClick()">
                                <img src="${require("@/assets/board/ph_copy.png")}" alt="">
                            </button>
                        </div>
                    </li>
                    <li>
                        <div class="pop_con_tit">글쓴이 계정</div>
                        <div class="pop_con_desc text">${data.author ? data.author : ""}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">전화번호</div>
                        <div class="pop_con_desc">${data.phoneNum ? data.phoneNum : ""}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">메신저 ID</div>
                        <div class="pop_con_desc">
                            <div class="sns_id">
                                ${data.messengerId ? data.messengerId : ""}
                            </div>
                        </div>
                    </li>
                </ul>
                <ul class="pop_con_w_50">
                    <li>
                        <div class="pop_con_tit">검색결과 등록일시</div>
                        <div class="pop_con_desc">${formatDate(data.createDate)}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">유형</div>
                        <div class="pop_con_desc">${type}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">세부유형</div>
                        <div class="pop_con_desc">
                        ${detailType}
                        </div>
                    </li>
                    <li>
                        <div class="pop_con_tit">유사도</div>
                        <div class="pop_con_desc">${data.similarity ? data.similarity : 0}%</div>
                    </li>

                </ul>
            </div>
            <ul class="pop_con_w_100">
                <li>
                    <div class="pop_con_tit">근거 내용</div>
                    <div class="pop_con_desc">
                        <div class="long_txt">
                            ${data.reasonContent ? data.reasonContent : ""}
                        </div>
                    </div>
                </li>
                <li>
                    <div class="pop_con_tit">해시태그</div>
                    <div class="pop_con_desc">
                        <div class="long_txt">
                            ${data.hashtag ? data.hashtag : ""}
                        </div>
                    </div>
                </li>
                <li>
                    <div class="pop_con_tit">내용</div>
                    <div class="pop_con_desc">
                        <div class="long_txt">
                            ${data.title ? data.title : ""}
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        `;
};

export const moreInfo = (data: any) => {
    return `
        <div class="pop_content_lists">
                    <ul>
                        <li>
                            <span>고유번호</span>
                            <p>${data.idx ? data.idx : ""}</p>
                        </li>
                        <li>
                            <span>검색유형</span>
                            <p>${data.strType ? data.strType : ""}</p>
                        </li>
                        <li>
                            <span>국적</span>
                            <p>${data.strNation ? data.strNation?.join(", ") : ""}</p>
                        </li>
                    </ul>
                    <ul>
                        <li>
                            <span>검색키워드</span>
                            <p>${data.keyword ? data.keyword : ""}</p>
                        </li>
                        <li>
                            <span>담당자</span>
                            <p>${data.meName ? data.meName : ""}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    `;
};

export const watcherInfo = (data: any) => {
    return `
        <div class="pop_content_lists watcher_bot">
                    <ul>
                        <li>
                            <span>상태</span>
                            <p>감지</p>
                        </li>
                        <li>
                            <span>카테고리</span>
                            <p>${data.category}</p>
                        </li>
                        <li>
                            <span>탐지근거</span>
                            <p>${data.detectionReason}</p>
                        </li>
                        <li>
                            <span>판단근거</span>
                            <p>${data.judgmentReason}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    `;
};

export const watcherbotSearch = (data: any) => {
    return `
    <div class="txt ">
        <div class="txt_flex">
            <ul class="pop_con_w_50">
                <li>
                    <div class="pop_con_tit">연번</div>
                    <div class="pop_con_desc">${data.idx}</div>
                </li>
                <li>
                    <div class="pop_con_tit">검색키워드</div>
                    <div class="pop_con_desc">${data.keyword}</div>
                </li>
                <li>
                    <div class="pop_con_tit">검색일시</div>
                    <div class="pop_con_desc">${formatDate(data.createDate)}</div>
                </li>
            </ul>
        </div>
    </div>
    `;
};

export const watcherbotResult = (data: any) => {
    return `
        <div class="thumb">
            <img src="${data.photoUrl ? data.photoUrl : require("@/assets/common/NoImg.png")}" alt="" onerror="this.src='${require("@/assets/common/NoImg.png")}'">
        </div>
        <div class="txt ">
            <div class="txt_flex">
                <ul class="">
                    <li>
                        <div class="pop_con_tit">고유번호</div>
                        <div class="pop_con_desc">${data.idx}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">맴버수</div>
                        <div class="pop_con_desc">${data.cntMembers?.toLocaleString()}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">등록일자</div>
                        <div class="pop_con_desc">${formatDate(data.createDate)}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">내용</div>
                        <div class="pop_con_desc">${data.title}</div>
                    </li>
                </ul>
            </div>
        </div>
        `;
};

export const watcherbotSearchResult = (data: ResultDetail) => {
    return `
        <div class="thumb">
            <img src="${data.file ? data.file : require("@/assets/common/NoImg.png")}" alt="" onerror="this.src='${require("@/assets/common/NoImg.png")}'">
        </div>
        <div class="txt ">
            <div class="txt_flex">
                <ul class="">
                    <li>
                        <div class="pop_con_tit">고유번호</div>
                        <div class="pop_con_desc">${data.idx}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">플랫폼</div>
                        <div class="pop_con_desc">${data.platform}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">제목</div>
                        <div class="pop_con_desc">${data.title}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">등록일자</div>
                        <div class="pop_con_desc">${formatDate(data.createDate)}</div>
                    </li>
                    <li>
                        <div class="pop_con_tit">카테고리</div>
                        <div class="pop_con_desc">${data.category}</div>
                    </li>
                </ul>
            </div>
			<ul class="pop_con_w_100">
                <li>
                    <div class="pop_con_tit">탐지 근거</div>
                    <div class="pop_con_desc">
                        <div class="long_txt">
                            ${data.detectionReason}
                        </div>
                    </div>
                </li>
                <li>
                    <div class="pop_con_tit">판단 근거</div>
                    <div class="pop_con_desc">
                        <div class="long_txt">
                            ${data.judgmentReason}
                        </div>
                    </div>
                </li>
                <li>
                    <div class="pop_con_tit">내용</div>
                    <div class="pop_con_desc">
                        <div class="long_txt">
                            ${data.content}
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        
    `;
};
